module.exports = __webpack_public_path__ + "static/media/clip.35fdfdc2.gif";